/**
 * Copyright (c) ACT, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/* eslint-disable filenames/match-exported */

export const DLS_COMPONENT_NAMES = {
  AREA_CHART: 'DlsAreaChart',
  BAR_CHART: 'DlsBarChart',
  HEAT_MAP: 'DlsHeatMap',
  LINE_CHART: 'DlsLineChart',
  MAP: 'DlsMap',
  OVERLAPPED_BAR_CHART: 'DlsOverlappedBarChart',
  PIE_CHART: 'DlsPieChart',
  SCATTER_PLOT: 'DlsScatterPlot',
  STACKED_BAR_CHART: 'DlsStackedBarChart',
} as const;

export default DLS_COMPONENT_NAMES;
